import { colors, createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    buttons: {
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(2),
      zIndex: 10
    },
    button: {
      margin: theme.spacing(1)
    },
    buttonDisabled: {
      '& > .MuiChip-label': {
        color: '#999 !important'
      }
    },
    expressionValidatorContainer: {
      // display: "inline-block",
      width: "100%",
      display: 'flex',
      flexDirection: "row",
      // paddingTop: "0",
      // paddingTop: theme.spacing(1),
      '& .MuiToolbar-gutters': {
        paddingLeft: theme.spacing(0),
        display: 'none'
      },
      '& .MuiCardContent-root': {
        // padding: theme.spacing(1),
        // display: "block",
        flexDirection: "row",
        width: "100%"
      }
    },
    autocomplete: {
      // padding: theme.spacing(1),
      // paddingTop: theme.spacing(3),
      marginLeft: 0,
      width: "100%",
      // maxWidth: "900px",
      [theme.breakpoints.down('md')]: {
        width: "100%"
      },
    },
    dateForm: {
      '& .MuiCardContent-root': {
        // display: 'block',
        padding: '12px',
        paddingTop: '0',
        marginLeft: '-4px',
        // paddingTop: "0"
        '& .MuiGrid-item': {
          padding: '12px'
        }
      }
    },
    formContainer: {
      '& .MuiCardContent-root': {
        display: 'block',
        // padding: theme.spacing(1),
        // paddingTop: "0"
      },
      [theme.breakpoints.down('md')]: {
        display: 'block',
        '&. MuiGrid-item': {
          maxWidth: "50px"
        }
      },
    },
    successMessage: {
      color: theme.palette.success.main,
      // fontWeight: 400,
      fontSize: 12,
      letterSpacing: '0.03333em'
    },
    errorMessage: {
      color: theme.palette.error.main,
      fontWeight: 400,
      fontSize: 12,
      letterSpacing: '0.03333em'
    },
    actionsContainer: { marginRight: theme.spacing(1) },
    textFieldLabelSuccess: {

      color: theme.palette.success.main
    },
    // textFieldLabelFocusedSuccess: {
    //   "&$textFieldLabelFocused": {
    //     color: theme.palette.success.main
    //   }
    // },
    textFieldSuccessInput: {
      "&MuiOutlinedInput-notchedOutline": {
        color: theme.palette.success.main
      }
    }
  });
